import type { TabKey } from './layout';

export const fullPath = (projectId: string, segment: TabKey) => `/projects/${projectId}/billing/${segment}`;
